import { toast } from "sonner";
import { PortalHeading } from "@/pages/portal/PortalLayout";
import { useFetch } from "@/hooks/useFetch";
import { api, fmtDate } from "@/lib/api";

export default function AdminOverview() {
  const { data: stats } = useFetch("/admin/stats");
  const { data, reload } = useFetch("/admin/inbox");
  const close = async (ref) => { await api.patch(`/admin/enquiries/${ref}`); toast.success("Enquiry closed"); reload(); };
  const cards = stats ? [["Quotes to review", stats.pending_quotes], ["Booking requests", stats.bookings], ["Active jobs", stats.active_jobs], ["Open enquiries", stats.enquiries]] : [];
  const open = (data?.enquiries || []).filter((e) => e.status !== "closed");
  return (
    <div data-testid="admin-overview">
      <PortalHeading title="Workshop overview" sub="Today's operational inbox." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(([l, v]) => <div key={l} className="rounded-2xl bg-[#020165] text-white p-5" data-testid={`admin-stat-${l.toLowerCase().replace(/ /g, "-")}`}><p className="font-display text-3xl font-extrabold">{v}</p><p className="text-xs text-white/60">{l}</p></div>)}
      </div>
      <section className="mt-6 rounded-2xl bg-white p-6">
        <h2 className="font-display font-bold text-lg mb-3">Enquiries & roadside requests</h2>
        {!open.length && <p className="text-sm text-[#56585E]">No open enquiries.</p>}
        <div className="divide-y">
          {open.map((e) => (
            <div key={e.reference || e.id} className="py-3 flex flex-wrap gap-3 items-start" data-testid={`admin-enquiry-${e.reference}`}>
              <span className={`text-[11px] font-bold uppercase rounded-full px-2 py-0.5 ${e.kind === "roadside" ? "bg-red-100 text-red-700" : "bg-[#020165]/10 text-[#020165]"}`}>{e.kind}</span>
              <div className="flex-1 min-w-[220px] text-sm"><p className="font-semibold">{e.name} · {e.phone || e.email} <span className="text-[#56585E] font-normal">· {e.reference} · {fmtDate(e.created_at)}</span></p>
                <p className="text-[#56585E]">{e.message || `${e.breakdown_type} at ${e.location} (${e.mobility})`}</p></div>
              <button onClick={() => close(e.reference)} data-testid={`admin-enquiry-close-${e.reference}`} className="text-xs underline">Mark handled</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
